export default "__VITE_ASSET__C09YTSL5__"